<template>
    <div>
        <candidate-banner></candidate-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="dash-inner-box">
                        <div class="dashboard-heading">
                            <h1>Loan Application Detail</h1>
                        </div>
                        <div class="row padd-top-10 padd-lr-15">
                            <div class="col-md-12">
                                <ul class="formNav">
                                     <li><button data-id="applicantProfile" class="topTab activeLi" @click="activeTab($event)">Applicant Profile</button></li> /
                                    <li><button data-id="parentsProfile" class="topTab" @click="activeTab($event)">Parents Profile</button></li> /
                                    <li><button data-id="guarantorProfile" class="topTab" @click="activeTab($event)">Guarantor's Profile</button></li>
                                </ul>
                                <form id="regForm">
                                    <div class="tab tabActive" id="applicantProfile">
                                        <!--                                <div class="row">-->
                                        <!--                                    <div class="col-md-12">-->
                                        <!--                                        <h4 class="cd-heading">Applicant Profile</h4>-->
                                        <!--                                    </div>-->
                                        <!--                                </div>-->
                                        <div class="row">
                                            <div class="col-md-4 col-sm-4 padd-20">
                                                <div class="form-group disFlex">
                                                    <label for="yourPic" class="input-group-text">
                                                        <div class="uploadPic">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                        </div>
                                                    </label>
                                                    <div class="ml20"> Upload Photo</div>
                                                    <input type="file" class="form-control pic" id="yourPic" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-3 col-sm-4 padd-20">
                                                <div class="form-group">
                                                    <label for="applicantName" class="input-group-text">
                                                        Name of Applicant
                                                    </label>
                                                    <input type="text" class="form-control" id="applicantName" placeholder="Enter Full Name" :value="data.applicant_name" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-4 padd-20">
                                                <div class="form-group">
                                                    <label for="applicantEmail" class="input-group-text">
                                                        Email
                                                    </label>
                                                    <input type="text" class="form-control" id="applicantEmail" :value="data.email" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-4 padd-20">
                                                <div class="form-group">
                                                    <label for="applicantDob" class="input-group-text">
                                                        DOB
                                                    </label>
                                                    <input type="text" class="form-control datepicker" id="applicantDob" placeholder="--/--/----" :value="data.applicant_dob" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-4 padd-20">
                                                <div class="form-group">
                                                    <label for="applicantNumber" class="input-group-text">
                                                        Mobile Number
                                                    </label>
                                                    <input type="text" class="form-control" id="applicantNumber" :value="data.phone" disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label class="radio-heading input-group-text" for="degreeApplied">
                                                        Degree Applied
                                                    </label>
                                                    <select class="form-control field-req"  name="years" id="degreeApplied" :value="data.degree" disabled>
                                                      <option value="">Select Degree</option>
                                                      <option value="Diploma">Diploma</option>
                                                      <option value="Graduation">Graduation</option>
                                                      <option value="Post Graduation">Post Graduation</option>
                                                      <option value="Professional Course">Professional Course</option>
                                                      <option value="Others">Others</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="courseApplied" class="input-group-text">
                                                        Course Applied
                                                    </label>
                                                    <input type="text" class="form-control" id="courseApplied" :value="data.course_name" disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <p class="cd-heading-2">2 ID or Residential Proofs Required</p>
                                            </div>
                                            <div class="col-md-6 col-sm-12 boder-left-1">
                                                <div class="row mt10 fieldsMain">
                                                    <div class="col-md-6 col-sm-6 padd-20">
                                                        <div class="form-group">
                                                            <label class="radio-heading input-group-text" for="applicantID">
                                                                ID Proof/Address Proof
                                                            </label>
                                                            <select class="form-control field-req" name="years" id="applicantID">
                                                                <option value="1">PAN</option>
                                                                <option value="2">Adhaar Card</option>
                                                                <option value="3">Passport</option>
                                                                <option value="4">Voter ID</option>
                                                                <option value="5">Driving License</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-sm-6 padd-20">
                                                        <div class="form-group">
                                                            <label for="applicantIDnumber" class="input-group-text">
                                                                Id Proof Number
                                                            </label>
                                                            <input type="text" class="form-control" id="applicantIDnumber" placeholder="Number">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 padd-20 text-center">
                                                        <div class="form-group">
                                                            <label for="applicantIDpic" class="">
                                                                <div class="idPhoto">
                                                                    <i class="fas fa-cloud-upload-alt"></i>
                                                                    Upload Photo
                                                                </div>
                                                            </label>
                                                            <input type="file" class="form-control idProof-input" id="applicantIDpic" placeholder="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="row mt10 fieldsMain">
                                                    <div class="col-md-6 col-sm-6 padd-20">
                                                        <div class="form-group">
                                                            <label class="radio-heading input-group-text" for="applicantIDtwo">
                                                                ID Proof/Address Proof
                                                            </label>
                                                            <select class="form-control field-req" name="years" id="applicantIDtwo">
                                                                <option value="1">PAN</option>
                                                                <option value="2">Adhaar Card</option>
                                                                <option value="3">Passport</option>
                                                                <option value="4">Voter ID</option>
                                                                <option value="5">Driving License</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-sm-6 padd-20">
                                                        <div class="form-group">
                                                            <label for="applicantIDTwoNum" class="input-group-text">
                                                                Id Proof Number
                                                            </label>
                                                            <input type="text" class="form-control" id="applicantIDTwoNum" placeholder="Number">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 padd-20 text-center">
                                                        <div class="form-group">
                                                            <label for="applicantIDTwoPic" class="">
                                                                <div class="idPhoto">
                                                                    <i class="fas fa-cloud-upload-alt"></i>
                                                                    Upload Photo
                                                                </div>
                                                            </label>
                                                            <input type="file" class="form-control idProof-input" id="applicantIDTwoPic" placeholder="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="FormDivider"></div>
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Residential Information</h4>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" :address-id="permanentAddress.loan_app_res_info_enc_id" data-type="address" v-if="permanentAddress.loan_app_res_info_enc_id" address_type="0">
                                            <div class="col-md-3 col-sm-6 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Permanent Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="address1" id="PA-owned" value="1" @change="saveData($event)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" id="PA-rented" name="address1" value="0" @change="saveData($event)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="houseNo" class="input-group-text">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="houseNo" placeholder="" data-name="address" @blur="saveData($event)" :value="permanentAddress.address">
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-6 padd-20">
                                                <div class="form-group citiesAuto">
                                                    <label for="PA-city" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="PA-city" placeholder="" data-name="city_id" @blur="saveData($event)" :value="permanentAddress.city_enc_id">
                                                    <ul class="college-list"></ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-6 padd-20">
                                                <div class="form-group statesAuto" id="states">
                                                    <label for="PA-state" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="PA-state" placeholder="" data-name="state_id" @blur="saveData($event)" :value="permanentAddress.state_enc_id">
                                                    <ul class="college-list"></ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" address-id="" data-type="address" address_type="0" v-else>
                                        <div class="col-md-3 col-sm-6 padd-20">
                                          <div class="form-group ">
                                            <div class="radio-heading input-group-text">
                                              Permanent Address
                                            </div>
                                            <ul class="displayInline">
                                              <li>
                                                <label class="container-radio">Owned
                                                  <input type="radio" name="address1" id="PA-owned" value="1" @change="saveData($event)">
                                                  <span class="checkmark"></span>
                                                </label>
                                              </li>
                                              <li>
                                                <label class="container-radio">Rented
                                                  <input type="radio" id="PA-rented" name="address1" value="0" @change="saveData($event)">
                                                  <span class="checkmark"></span>
                                                </label>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div class="col-md-3 col-sm-6 padd-20">
                                          <div class="form-group">
                                            <label for="houseNo" class="input-group-text">
                                              Address
                                            </label>
                                            <input type="text" class="form-control" id="houseNo" placeholder="" data-name="address" @blur="saveData($event)">
                                          </div>
                                        </div>
                                        <div class="col-md-3 col-sm-6 padd-20">
                                          <div class="form-group citiesAuto">
                                            <label for="PA-city" class="input-group-text">
                                              City
                                            </label>
                                            <input type="text" class="form-control" id="PA-city" placeholder="" data-name="city_id" @blur="saveData($event)">
                                            <ul class="college-list"></ul>
                                          </div>
                                        </div>
                                        <div class="col-md-3 col-sm-6 padd-20">
                                          <div class="form-group statesAuto" id="states">
                                            <label for="PA-state" class="input-group-text">
                                              State
                                            </label>
                                            <input type="text" class="form-control" id="PA-state" placeholder="" data-name="state_id" @blur="saveData($event)">
                                            <ul class="college-list"></ul>
                                          </div>
                                        </div>
                                      </div>
                                        <div class="row mt10 fieldsMain" :address-id="currentAddress.loan_app_res_info_enc_id" data-type="address" v-if="currentAddress.loan_app_res_info_enc_id" address_type="1">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Current Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="address2" id="CA-owned" value="1" @change="saveData($event)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" name="address2" id="CA-rented" value="0" @change="saveData($event)">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label class="input-group-text" for="CA-houseNo">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="CA-houseNo" placeholder="" data-name="address" @blur="saveData($event)" :value="currentAddress.address">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group citiesAuto">
                                                    <label for="CA-city" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="CA-city" placeholder="" data-name="city_id" @blur="saveData($event)" :value="currentAddress.city_enc_id">
                                                    <ul class="college-list"></ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group statesAuto">
                                                    <label for="CA-state" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="CA-state" placeholder="" data-name="state_id" @blur="saveData($event)" :value="currentAddress.state_enc_id">
                                                    <ul class="college-list"></ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" address-id="" data-type="address" address_type="1" v-else>
                                        <div class="col-md-3 padd-20">
                                          <div class="form-group ">
                                            <div class="radio-heading input-group-text">
                                              Current Address
                                            </div>
                                            <ul class="displayInline">
                                              <li>
                                                <label class="container-radio">Owned
                                                  <input type="radio" name="address2" id="CA-owned" value="1" @change="saveData($event)">
                                                  <span class="checkmark"></span>
                                                </label>
                                              </li>
                                              <li>
                                                <label class="container-radio">Rented
                                                  <input type="radio" name="address2" id="CA-rented" value="0" @change="saveData($event)">
                                                  <span class="checkmark"></span>
                                                </label>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div class="col-md-3 padd-20">
                                          <div class="form-group">
                                            <label class="input-group-text" for="CA-houseNo">
                                              Address
                                            </label>
                                            <input type="text" class="form-control" id="CA-houseNo" placeholder="" data-name="address" @blur="saveData($event)">
                                          </div>
                                        </div>
                                        <div class="col-md-3 padd-20">
                                          <div class="form-group citiesAuto">
                                            <label for="CA-city" class="input-group-text">
                                              City
                                            </label>
                                            <input type="text" class="form-control" id="CA-city" placeholder="" data-name="city_id" @blur="saveData($event)">
                                            <ul class="college-list"></ul>
                                          </div>
                                        </div>
                                        <div class="col-md-3 padd-20">
                                          <div class="form-group statesAuto">
                                            <label for="CA-state" class="input-group-text">
                                              State
                                            </label>
                                            <input type="text" class="form-control" id="CA-state" placeholder="" data-name="state_id" @blur="saveData($event)">
                                            <ul class="college-list"></ul>
                                          </div>
                                        </div>
                                      </div>
                                        <div class="FormDivider"></div>
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Education</h4>
                                            </div>
                                        </div>
                                        <div v-if="data && data.loanCandidateEducations.length">
                                        <div class="row mt10 fieldsMain" :qualification-id="qList.loan_candidate_edu_enc_id" data-type="qualification" v-for="qList in data.loanCandidateEducations">
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="class10" class="input-group-text">
                                                        Qualification
                                                    </label>
                                                    <input type="text" class="form-control" id="class10" placeholder="Class Name eg. +2 or 10th" @blur="saveData($event)" data-name="name" :value="qList.name">
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="instituteName" class="input-group-text">
                                                        Name Of Institution
                                                    </label>
                                                    <input type="text" class="form-control" id="instituteName" placeholder="" @blur="saveData($event)" data-name="institution" :value="qList.institution">
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="10thmarksObtained" class="input-group-text">
                                                        Marks Obtained
                                                    </label>
                                                    <input type="number" class="form-control" id="10thmarksObtained" placeholder="" @blur="saveData($event)" data-name="obtained_marks" :value="qList.obtained_marks">
                                                </div>
                                            </div>
                                        </div>
                                          <div class="row mt10 fieldsMain" qualification-id="" data-type="qualification">
                                            <div class="col-md-4 col-sm-6 padd-20">
                                              <div class="form-group">
                                                <label for="class12" class="input-group-text">
                                                  Qualification
                                                </label>
                                                <input type="text" class="form-control" id="class12" placeholder="+2" @blur="saveData($event)" data-name="name">
                                              </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                              <div class="form-group">
                                                <label for="class12Institution" class="input-group-text">
                                                  Name Of Institution
                                                </label>
                                                <input type="text" class="form-control" id="class12Institution" placeholder="" @blur="saveData($event)" data-name="institution">
                                              </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                              <div class="form-group">
                                                <label for="class12marks" class="input-group-text">
                                                  Marks Obtained
                                                </label>
                                                <input type="text" class="form-control" id="class12marks" placeholder="" @blur="saveData($event)" data-name="obtained_marks">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else>
                                        <div class="row mt10 fieldsMain" qualification-id="" data-type="qualification">
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="class12" class="input-group-text">
                                                        Qualification
                                                    </label>
                                                    <input type="text" class="form-control" id="class12" placeholder="+2" @blur="saveData($event)" data-name="name">
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="class12Institution" class="input-group-text">
                                                        Name Of Institution
                                                    </label>
                                                    <input type="text" class="form-control" id="class12Institution" placeholder="" @blur="saveData($event)" data-name="institution">
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-6 padd-20">
                                                <div class="form-group">
                                                    <label for="class12marks" class="input-group-text">
                                                        Marks Obtained
                                                    </label>
                                                    <input type="text" class="form-control" id="class12marks" placeholder="" @blur="saveData($event)" data-name="obtained_marks">
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div id="eduFields">

                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <button type="button" class="eduBtn2" @click="addEduField()">Add More</button>
                                            </div>
                                        </div>
                                        <div class="text-center">
                                            <button type="button" class="eduBtn" data-id="parentsProfile" @click="activeTab($event)">Next</button>
                                        </div>
                                    </div>
                                    <div class="tab" id="parentsProfile">
                                        <!--                                <div class="row">-->
                                        <!--                                    <div class="col-md-12">-->
                                        <!--                                        <h4 class="cd-heading">Parents Profile</h4>-->
                                        <!--                                    </div>-->
                                        <!--                                </div>-->
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Father's Information</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-4 padd-20">
                                                <div class="form-group disFlex">
                                                    <label for="fatherPic" class="input-group-text">
                                                        <div class="uploadPic">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                        </div>
                                                    </label>
                                                    <div class="ml20"> Upload Photo</div>
                                                    <input type="file" class="form-control pic idProof-input" id="fatherPic" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" data-type="co_applicant" :co_applicant-id="coApplicantFather.loan_co_app_enc_id" data-relation="Father">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fatherName" class="input-group-text">
                                                        Name
                                                    </label>
                                                    <input type="text" class="form-control" id="fatherName" placeholder="Enter Full Name" :value="coApplicantFather.name" data-name="name" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fatherEmail" class="input-group-text">
                                                        Email
                                                    </label>
                                                    <input type="text" class="form-control" id="fatherEmail" :value="coApplicantFather.email" data-name="email" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fatherDob" class="input-group-text">
                                                        DOB
                                                    </label>
                                                    <input type="text" class="form-control datepicker" id="fatherDob" placeholder="--/--/----" :value="coApplicantFather.co_applicant_dob" data-name="co_applicant_dob" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fatherNumber" class="input-group-text">
                                                        Mobile Number
                                                    </label>
                                                    <input type="text" class="form-control" id="fatherNumber" :value="coApplicantFather.phone" data-name="phone" @blur="saveData($event)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="checkcontainer">Same As Above
                                                                <input type="checkbox" data-id="fAddress" id="fSame" @change="hideAddress()" data-name="address">
                                                                <span class="Ch-checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" id="fAddress" data-type="address" address-id="" :data-co-id="coApplicantFatherId" v-if="coApplicantFatherId">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Residence Type
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" name="residence_type" id="FRT-rented" value="0" data-name="res_type">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="residence_type" id="FRT-owned" value="1" data-name="res_type">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fHouseNo" class="input-group-text">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="fHouseNo" placeholder="" data-name="address" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fCity" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="fCity" placeholder="" data-name="city_id" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="fState" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="fState" placeholder="state_id" @blur="saveData($event)">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label class="radio-heading input-group-text" for="fIDproof">
                                                        ID Proof/Address Proof
                                                    </label>
                                                    <select class="form-control field-req" name="years" id="fIDproof">
                                                        <option value="1">PAN</option>
                                                        <option value="2">Adhaar Card</option>
                                                        <option value="3">Passport</option>
                                                        <option value="4">Voter ID</option>
                                                        <option value="5">Driving License</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="fIDproofnumber" class="input-group-text">
                                                        Id Proof Number
                                                    </label>
                                                    <input type="text" class="form-control" id="fIDproofnumber" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group text-center">
                                                    <label for="idProofFather" class="">
                                                        <div class="idPhoto">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                            Upload ID Proof's Photo
                                                        </div>
                                                    </label>
                                                    <input type="file" class="form-control idProof-input" id="idProofFather" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="yearsOFoccu" class="input-group-text">
                                                        Years Of Occupancy In Current House
                                                    </label>
                                                    <input type="text" class="form-control" id="yearsOFoccu" placeholder="">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="fOccupation" class="input-group-text">
                                                        Occupation
                                                    </label>
                                                    <select class="form-control field-req" id="fOccupation" :value="coApplicantFather.employment_type">
                                                      <option value="1">Salaried</option>
                                                      <option value="2">Self-employed</option>
                                                      <option value="0">Non-Working</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="fIncome" class="input-group-text">
                                                        Annual Income
                                                    </label>
                                                    <input type="text" class="form-control" id="fIncome" :value="coApplicantFather.annual_income">
                                                </div>
                                            </div>
                                        </div>


                                        <div class="FormDivider"></div>
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Mother's Information</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-4 padd-20">
                                                <div class="form-group disFlex">
                                                    <label for="MPic" class="input-group-text">
                                                        <div class="uploadPic">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                        </div>
                                                    </label>
                                                    <div class="ml20"> Upload Photo</div>
                                                    <input type="file" class="form-control pic idProof-input" id="MPic" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MName" class="input-group-text">
                                                        Name
                                                    </label>
                                                    <input type="text" class="form-control" id="MName" placeholder="Enter Full Name" :value="coApplicantMother.name">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MEmail" class="input-group-text">
                                                        Email
                                                    </label>
                                                    <input type="text" class="form-control" id="MEmail"  :value="coApplicantMother.email">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MDob" class="input-group-text">
                                                        DOB
                                                    </label>
                                                    <input type="text" class="form-control datepicker" id="MDob" placeholder="--/--/----" :value="coApplicantMother.co_applicant_dob">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label class="input-group-text" for="M-mobile">
                                                        Mobile Number
                                                    </label>
                                                    <input type="text" class="form-control" id="M-mobile" :value="coApplicantMother.phone">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="checkcontainer">Same As Above
                                                                <input type="checkbox" data-id="mAddress" @change="hideAddress()">
                                                                <span class="Ch-checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10" id="mAddress">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Residence Type
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" checked="checked" name="MRT-rented" id="MRT-rented">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="MRT-owned" id="MRT-owned">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MHouseNo" class="input-group-text">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="MHouseNo" placeholder="">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MCity" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="MCity" placeholder="">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="MState" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="MState" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label class="radio-heading input-group-text" for="MIdProof">
                                                        ID Proof/Address Proof
                                                    </label>
                                                    <select class="form-control field-req" name="years" id="MIdProof">
                                                        <option value="1">PAN</option>
                                                        <option value="2">Adhaar Card</option>
                                                        <option value="3">Passport</option>
                                                        <option value="4">Voter ID</option>
                                                        <option value="5">Driving License</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="MIdProofNo" class="input-group-text">
                                                        Id Proof Number
                                                    </label>
                                                    <input type="text" class="form-control" id="MIdProofNo" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group text-center">
                                                    <label for="idProofMother" class="">
                                                        <div class="idPhoto">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                            Upload ID Proof's Photo
                                                        </div>
                                                    </label>
                                                    <input type="file" class="form-control idProof-input" id="idProofMother" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="mOccupation" class="input-group-text">
                                                        Occupation
                                                    </label>
                                                    <select class="form-control field-req" id="mOccupation">
                                                        <option value="1">Salaried</option>
                                                        <option value="2">Self-employed</option>
                                                        <option value="3">Home-maker</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="familyIncome" class="input-group-text">
                                                        Family Income(Annually)
                                                    </label>
                                                    <input type="text" class="form-control" id="familyIncome" :value="coApplicantMother.annual_income">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <div class="radio-heading input-group-text">
                                                        Siblings
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="checkcontainer">Yes, I have Sibligs.
                                                                <input type="checkbox" data-id="siblingInfo" @change="ShowSibling()">
                                                                <span class="Ch-checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10" id="siblingInfo">
                                            <div class="col-md-12">
                                                <p class="cd-heading-2">Sibling Information</p>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="siblingName" class="input-group-text">
                                                        Name
                                                    </label>
                                                    <input type="text" class="form-control" id="siblingName" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="siblingAge" class="input-group-text">
                                                        Age
                                                    </label>
                                                    <input type="text" class="form-control" id="siblingAge" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="siblingOccupation" class="input-group-text">
                                                        Occupation
                                                    </label>
                                                    <input type="text" class="form-control" id="siblingOccupation" placeholder="Number">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center">
                                            <button type="button" class="eduBtn eduBtnLight" data-id="applicantProfile" @click="activeTab($event)">Previous</button>
                                            <button type="button" class="eduBtn" data-id="guarantorProfile" @click="activeTab($event)">Next</button>
                                        </div>
                                    </div>
                                    <div class="tab" id="guarantorProfile">
                                        <!--                                <div class="row">-->
                                        <!--                                    <div class="col-md-12">-->
                                        <!--                                        <h4 class="cd-heading">Guarantor's Profile</h4>-->
                                        <!--                                    </div>-->
                                        <!--                                </div>-->
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Guarantor 1</h4>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" data-type="co_applicant" :co_applicant-id="guarantor.loan_co_app_enc_id" data-relation="Guarantor">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1Name" class="input-group-text">
                                                        Name
                                                    </label>
                                                    <input type="text" class="form-control" id="G1Name" placeholder="Enter Full Name" data-name="name" :value="guarantor.name" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1Email" class="input-group-text">
                                                        Email
                                                    </label>
                                                    <input type="text" class="form-control" id="G1Email" placeholder="" data-name="email" :value="guarantor.email" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1Dob" class="input-group-text">
                                                        DOB
                                                    </label>
                                                    <input type="text" class="form-control datepicker" id="G1Dob" placeholder="--/--/----">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1number" class="input-group-text">
                                                        Mobile Number
                                                    </label>
                                                    <input type="text" class="form-control" id="G1number" placeholder="" data-name="phone" :value="guarantor.phone" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="checkcontainer">Same As Above
                                                                <input type="checkbox" data-id="gAddress1" @change="hideAddress()" data-name="address">
                                                                <span class="Ch-checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" id="gAddress1" data-type="address" address-id="" :data-co-id="guarantor.loan_co_app_enc_id">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Residence Type
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" checked="checked" name="G1-RT" id="G1-rented" value="0" data-name="res_type">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="G1-RT" id="G1-owned" value="1" data-name="res_type">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1Address" class="input-group-text">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="G1Address" placeholder="" data-name="address" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1City" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="G1City" placeholder="" data-name="city_id" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G1state" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="G1state" placeholder="" @blur="saveData($event)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label class="radio-heading input-group-text" for="G1ID">
                                                        ID Proof/Address Proof
                                                    </label>
                                                    <select class="form-control field-req" name="" id="G1ID">
                                                        <option value="1">PAN</option>
                                                        <option value="2">Adhaar Card</option>
                                                        <option value="3">Passport</option>
                                                        <option value="4">Voter ID</option>
                                                        <option value="5">Driving License</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="G1IDnumber" class="input-group-text">
                                                        Id Proof Number
                                                    </label>
                                                    <input type="text" class="form-control" id="G1IDnumber" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group text-center">
                                                    <label for="G1IDpic" class="">
                                                        <div class="idPhoto">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                            Upload ID Proof's Photo
                                                        </div>
                                                    </label>
                                                    <input type="file" class="form-control idProof-input" id="G1IDpic" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="FormDivider"></div>
                                        <div class="row mt10">
                                            <div class="col-md-12">
                                                <h4 class="cd-heading-3">Guarantor 2</h4>
                                            </div>
                                        </div>
                                        <div class="row mt10 fieldsMain" data-type="co_applicant" :co_applicant-id="guarantor2.loan_co_app_enc_id" data-relation="Guarantor">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2name" class="input-group-text">
                                                        Name
                                                    </label>
                                                    <input type="text" class="form-control" id="G2name" placeholder="Enter Full Name" data-name="name" :value="guarantor2.name" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2email" class="input-group-text">
                                                        Email
                                                    </label>
                                                    <input type="text" class="form-control" id="G2email" placeholder="" data-name="email" :value="guarantor2.email" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2Dob" class="input-group-text">
                                                        DOB
                                                    </label>
                                                    <input type="text" class="form-control datepicker" id="G2Dob" placeholder="--/--/----">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2number" class="input-group-text">
                                                        Mobile Number
                                                    </label>
                                                    <input type="text" class="form-control" id="G2number" placeholder="" data-name="phone" :value="guarantor2.phone" @blur="saveData($event)">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Address
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="checkcontainer">Same As Above
                                                                <input type="checkbox" data-id="gAddress2" @change="hideAddress()">
                                                                <span class="Ch-checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10" id="gAddress2">
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group ">
                                                    <div class="radio-heading input-group-text">
                                                        Residence Type
                                                    </div>
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Rented
                                                                <input type="radio" checked="checked" name="G2address">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">Owned
                                                                <input type="radio" name="G2address">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2houseNo" class="input-group-text">
                                                        Address
                                                    </label>
                                                    <input type="text" class="form-control" id="G2houseNo" placeholder="">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2city" class="input-group-text">
                                                        City
                                                    </label>
                                                    <input type="text" class="form-control" id="G2city" placeholder="">
                                                </div>
                                            </div>
                                            <div class="col-md-3 padd-20">
                                                <div class="form-group">
                                                    <label for="G2state" class="input-group-text">
                                                        State
                                                    </label>
                                                    <input type="text" class="form-control" id="G2state" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt10">
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label class="radio-heading input-group-text" for="G2ID">
                                                        ID Proof/Address Proof
                                                    </label>
                                                    <select class="form-control field-req" name="years" id="G2ID">
                                                        <option value="1">PAN</option>
                                                        <option value="2">Adhaar Card</option>
                                                        <option value="3">Passport</option>
                                                        <option value="4">Voter ID</option>
                                                        <option value="5">Driving License</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group">
                                                    <label for="G2IDnumber" class="input-group-text">
                                                        Id Proof Number
                                                    </label>
                                                    <input type="text" class="form-control" id="G2IDnumber" placeholder="Number">
                                                </div>
                                            </div>
                                            <div class="col-md-4 padd-20">
                                                <div class="form-group text-center">
                                                    <label for="G2IDpic" class="">
                                                        <div class="idPhoto">
                                                            <i class="fas fa-cloud-upload-alt"></i>
                                                            Upload ID Proof's Photo
                                                        </div>
                                                    </label>
                                                    <input type="file" class="form-control idProof-input" id="G2IDpic" placeholder="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center">
                                            <button type="button" class="eduBtn eduBtnLight"data-id="parentsProfile" @click="activeTab($event)">Previous</button>
                                            <button type="button" class="eduBtn" onclick="">Update</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">

            </div>
        </div>
    </div>
</template>

<script>
    import CandidateBanner from "../../components/candidateBanner";
    import axios from "axios";
    import Autocomplete from '@trevoreyre/autocomplete-js';
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CandidateBanner
        },
        data(){
            return{
                data:"",
                coApplicants:"",
                coApplicantFather: "",
                coApplicantMother: "",
                coApplicantFatherId:"",
                addresses:"",
                permanentAddress:"",
                currentAddress:"",
                guarantor:"",
                guarantor2:"",
            }
        },
        mounted(){
            var t = this;
            if (!document.getElementById('my-datepicker')) {
            var scriptTag = document.createElement("script");
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
            scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js";
            scriptTag.id = "my-datepicker";
            document.getElementsByTagName('head')[0].appendChild(link);
            document.getElementsByTagName('head')[0].appendChild(scriptTag);
          }
            t.getData();
        },
        methods:{
            getData(){
              var t = this;
              var url = this.$store.getters.getDomain;

              axios.post(`${url}api/v3/education-loan/get-loan`, {loan_app_enc_id:t.$route.query.id}, {headers: requestHeaders()}).then(function (response) {
                if(response['data']['response']['status'] === 200) {
                  t.data = response['data']['response']['data'];
                      t.coApplicants = response['data']['response']['data'].loanCoApplicants;
                      t.addresses = response['data']['response']['data'].loanApplicantResidentialInfos;
                      t.initializeData();
                }
              });
            },
            saveData(event){
              console.log('enter');
              var t = this;
              var url = this.$store.getters.getDomain;

              var element = event.currentTarget;
              var elemParent = element.closest('.fieldsMain');
              var obj = {};
              obj["loan_app_id"] = t.$route.query.id;
              obj["type"] = elemParent.getAttribute('data-type');
              obj["id"] = elemParent.getAttribute(elemParent.getAttribute('data-type')+'-id');
              if(!elemParent.getAttribute(elemParent.getAttribute('data-type')+'-id') && !element.value){
                  return false;
              }
              if(elemParent.getAttribute('address_type')){
                  obj['address_type'] = elemParent.getAttribute('address_type');
              }
              if(elemParent.getAttribute('data-relation')){
                  obj['relation'] = elemParent.getAttribute('data-relation');
              }
              if(elemParent.getAttribute('data-co-id')){
                  obj['loan_co_app_id'] = elemParent.getAttribute('data-co-id');
              }
              obj[element.getAttribute('data-name')] = element.value;

              axios.post(`${url}api/v2/loans/loan-second-form`, obj, {headers: requestHeaders()}).then(function (response) {
                if(response['data']['response']['status'] === 200) {
                  elemParent.setAttribute(elemParent.getAttribute('data-type')+'-id',response['data']['response']['id']);
                  console.log('done');
                  if(elemParent.getAttribute('data-type') == 'co_applicant'){
                  console.log('done1');
                      if(elemParent.getAttribute('data-relation') == 'Father'){
                  console.log('done2');
                        t.coApplicantFatherId = response['data']['response']['id'];
                      } else if(elemParent.getAttribute('data-relation') == 'Father'){

                      }
                  }
                }
              });
            },
            initializeData(){
                var t = this;
                $('.datepicker').datepicker({
                    autoclose: true,
                    format: 'yyyy-mm-dd',
                });
                if(t.coApplicants.length) {
                    for (var i = 0; i < t.coApplicants.length; i++) {
                      if (t.coApplicants[i].relation == "Father") {
                        t.coApplicantFather = t.coApplicants[i];
                        t.coApplicantFatherId = t.coApplicantFather.loan_co_app_enc_id;
                      } else if (t.coApplicants[i].relation == "Mother") {
                        t.coApplicantMother = t.coApplicants[i];
                      } else if (t.coApplicants[i].relation == "Guarantor") {
                           if(!t.guarantor){
                               t.guarantor = t.coApplicants[i];
                           } else {
                               t.guarantor2 = t.coApplicants[i];
                           }
                      }
                    }
                }
                if(t.addresses.length){
                  for (var i = 0; i < t.addresses.length; i++) {
                    if (t.addresses[i].residential_type == "0") {
                      t.permanentAddress = t.addresses[i];
                    } else if(t.addresses[i].residential_type == "1") {
                      t.currentAddress = t.addresses[i];
                    }
                  }
                }
                t.initCities();
                t.initStates();
            },
            initStates(){
              var statesElems = document.getElementsByClassName('statesAuto');
              for (var s = 0;s<statesElems.length;s++){
                new Autocomplete(statesElems[s], {
                  search: input => {
                    const domain = this.$store.getters.getDomain
                    const url = `${domain}api/v2/utilities/get-states?search=${encodeURI(input)}`

                    return new Promise(resolve => {
                      if (input.length < 1) {
                        return resolve([])
                      }

                      fetch(url)
                          .then(response => response.json())
                          .then(data => {
                            resolve(data)
                          })
                    })
                  },
                  renderResult: (result, props) => `
                  <li ${props}>
                    <div class="ss-description">
                      ${result.name}
                    </div>
                  </li>
              `,
                  getResultValue: result => result.name,
                  onSubmit: result => {
                    // t.institute_name = result['name'];
                    // t.college_selected = result['organization_enc_id'];
                    // t.org_img = result['organization_logo'];
                    // t.courses = result['courses'];
                    // t.business_activity = result['business_activity'];
                    // $('#myModal').css({"display": "none"});
                  }
                });
              }
            },
            initCities(){
              var citiesElems = document.getElementsByClassName('citiesAuto');
              for (var c = 0;c<citiesElems.length;c++){
                new Autocomplete(citiesElems[c], {
                  search: input => {
                    const domain = this.$store.getters.getDomain
                    const url = `${domain}api/v2/utilities/get-cities?search=${encodeURI(input)}`

                    return new Promise(resolve => {
                      if (input.length < 1) {
                        return resolve([])
                      }

                      fetch(url)
                          .then(response => response.json())
                          .then(data => {
                            resolve(data)
                          })
                    })
                  },
                  renderResult: (result, props) => `
                    <li ${props}>
                      <div class="ss-description">
                        ${result.name}
                      </div>
                    </li>
                `,
                  getResultValue: result => result.name,
                  onSubmit: result => {
                    // t.institute_name = result['name'];
                  }
                });
              }
            },
            activeTab(event) {
              let tabs = document.getElementsByClassName('tabActive');
              for(var i = 0; i < tabs.length; i++){
                tabs[i].classList.remove('tabActive');
              }
              let activeLi = document.getElementsByClassName('activeLi');
              for(var j = 0; j < activeLi.length; i++){
                activeLi[j].classList.remove('activeLi');
              }

              let activeID = event.currentTarget.getAttribute('data-id');
              let activeTab = document.getElementById(activeID);
              activeTab.classList.add('tabActive');
              let selectedTp = document.querySelector('[data-id="'+activeID+'"]');
              selectedTp.classList.add('activeLi');
              window.scrollTo(0,0);
            },
            hideAddress(){
              let clickedElem = event.currentTarget;
              let addressCheck = event.currentTarget.getAttribute('data-id')
              let  elemHide = document.getElementById(addressCheck);

              if(clickedElem.checked == true){
                elemHide.style.display = 'none';
              }else{
                elemHide.style.display = 'block';
              };
            },
            addEduField() {
                let eduTemp = [`<div class="col-md-4 padd-20"><div class="form-group"><label for="number" class="input-group-text">Qualification</label><input type="text" class="form-control" id="" placeholder="Degree Name" value=""></div></div><div class="col-md-4 padd-20"><div class="form-group"><label for="number" class="input-group-text">Name Of Institution</label><input type="text" class="form-control" id="" placeholder=""></div></div><div class="col-md-4 padd-20"><div class="form-group"><label for="number" class="input-group-text">Marks Obtained</label><input type="text" class="form-control" id="" placeholder=""></div></div>`];

                let eduFields = document.getElementById('eduFields');
                let newFields = document.createElement('div');
                newFields.setAttribute('class', 'row');
                newFields.innerHTML = eduTemp;

                eduFields.appendChild(newFields)
             },
            ShowSibling() {
                let clickedElem = event.currentTarget;
                let addressCheck = event.currentTarget.getAttribute('data-id')
                let elemHide = document.getElementById(addressCheck);
                if(clickedElem.checked == true){
                    elemHide.style.display = 'block';
                }else{
                    elemHide.style.display = 'none';
                };
            }
        },
    }
</script>

<style scoped>
    .activeLi{
        color: #00a0e3 !important;
    }
    #siblingInfo{
        display: none;
    }
    .padd-lr-15{
        padding: 0 15px;
    }
    .mt10{
        margin-top: 10px;
    }
    .mt20{
        margin-top: 20px;
    }
    .boder-left-1{
        border-right:1px solid #eee;
    }
    .cd-heading{
        font-size: 18px;
        font-weight: bold;
        color: #000;
    }
    .cd-heading-3{
        font-size: 16px;
        font-weight: bold;
        color: #00a0e3;
    }
    .uploadPic{
        height: 80px;
        width: 80px;
        border-radius: 50%;
        border: 1px solid #eee;
        display: flex;
        align-items:center;
        justify-content: center;
        margin-top: 20px;
    }
    #yourPic, #idProof, .idProof-input{
        display: none !important;
    }
    .disFlex{
        display: flex;
        align-items: center;
    }
    .uploadPic i{
        font-size: 30px;
        color: #00a0e3;
    }
    .ml20{
        margin-left: 10px;
        font-weight: bold;
    }
    .idPhoto{
        display: flex;
        align-items: center;
        background: #00a0e3;
        color: #fff;
        font-weight: normal;
        padding: 5px 10px;
        margin-top: 33px;
    }
    .idPhoto i{
        font-size: 18px;
        margin-right: 10px;
    }
    .eduBtn{

        background: #00a0e3;
        color: #fff;
        border: 1px solid #00a0e3;
        padding: 5px 15px;
        font-size: 16px;
        margin: 15px auto;
    }
    .eduBtnLight{
        background: #eee;
        color: #00a0e3;
        border: 1px solid #eee;

    }
    .eduBtn2{
        background: transparent;
        color: #00a0e3;
        border: none;
        padding: 0;
        font-size: 16px;
        margin: 5px auto;
        text-transform: uppercase;
    }
    .eduBtn:hover{
        background: #fff;
        color: #00a0e3;
    }
    .font-dark > span > i {
        font-size: 13px;
        margin-left: 5px;
        color: darkgray;
    }
    .input-group-text {
        font-weight: bold;
        font-family: lora;
        color: #000;
        font-size: 15px;
    }

    .container-radio {
        display: block;
        position: relative;
        padding-left: 29px;
        margin-bottom: 5px;
        cursor: pointer;
        font-size: 16px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .container-radio input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .checkmark {
        position: absolute;
        top: 0px;
        left: 0;
        height: 22px;
        width: 22px;
        background-color: #eee;
        border-radius: 50%;
    }

    .container-radio:hover input ~ .checkmark {
        background-color: #ccc;
    }

    .container-radio input:checked ~ .checkmark {
        background-color: #2196F3;
    }
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .container-radio input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .container-radio .checkmark:after {
        top: 6px;
        left: 6px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: white;
    }
    .displayInline{
        padding-inline-start: 0px;
    }
    .displayInline li {
        display: inline-block;
        padding-right: 20px;
        margin-top: 5px;
    }
    .FormDivider{
        height: 1px;
        background: #eee;
        max-width: 100%;
        margin: 20px auto;
    }
    .cd-heading{
        font-weight: bold;
        font-family: roboto;
        color: #00a0e3;
        text-transform: uppercase;
    }
    /*chcekbox*/
    .checkcontainer {
        display: block;
        position: relative;
        padding-left: 28px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 16px;
        font-family: roboto;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser\'s default checkbox */
    .checkcontainer input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .Ch-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 22px;
        width: 22px;
        background-color: transparent;
        border: 1px solid #c2cad8;
    }

    /* On mouse-over, add a grey background color */
    .checkcontainer:hover input ~ .Ch-checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .checkcontainer input:checked ~ .Ch-checkmark {
        background-color: #2196F3;
        border: 1px solid #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .Ch-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checkcontainer input:checked ~ .Ch-checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkcontainer .Ch-checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid white !important;
        border-width: 0 3px 3px 0 !important;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .tab {
        display: none;
        padding: 20px 10px;
    }
    .tabActive{
        display: block;
    }
    .cd-heading-2{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        font-family: lora;
        margin-bottom: 0px;
        margin-top: 5px;
    }
    .formNav{
        padding-inline-start: 0px;
    }
    .formNav li{
        display: inline;
        list-style-type: none;
    }
    .formNav li button{
        background: transparent;
        font-size: 18px;
        color: #666;
        border: none;

    }
    .form-control {
        width: 100%;
        height: 45px;
        padding: 6px 12px;
        background-color: #fff;
        border: 1px solid #c2cad8;
        border-radius: 0px;
        box-shadow: none;

    }
    @media screen and (max-width: 992px){
        .idPhoto{
            margin: 10px 0 20px 0;
        }
    }
</style>